// Centralized Korean label mappings for shared enum types.
//
// Plan v0.3.0 §B-4 — until v0.2.0, RobotStatus etc. were displayed
// either as the raw enum (READY_TO_SHIP) or with ad-hoc inline mappings
// scattered across pages. The PPTX feedback (Slide 2 — pp.2) explicitly
// requires Korean operator-friendly labels, so collect them here and
// re-export so DashboardPage / RobotsListPage / RobotDetailPage /
// RobotEditModal etc. all stay in sync.
//
// Keep this file additive: new enum values land in @bhops/shared first
// (canonical source) and gain a label here on the next render touch.
//
// NOTE: this is a *display* layer. Enum values stored in the database
// and over the wire stay as the canonical English identifiers (e.g.
// READY_TO_SHIP). Only the rendered text is Korean.

import type { RobotStatus } from '@bhops/shared';

export const ROBOT_STATUS_LABEL: Record<RobotStatus, string> = {
  IN_PRODUCTION: '생산 중',
  READY_TO_SHIP: '출하 준비',
  // S2 §9.1 — 설치 대기 (제조 할당+설치일정 확정 후 ~ 인수 전).
  INSTALL_PENDING: '설치 대기',
  DEPLOYED: '운영 중',
  IN_AS: '정비 중',
  // round10 요구2 — 폐기 예정(장부 잔존) vs 폐기 완료(상각) 구분.
  RETIRED: '폐기 완료',
  // shared/enums.ts 에 추가된 보관 단계. StatusPill 과 동일한 라벨 사용
  // (BOM 일관성).
  IN_STORAGE: '창고 보관',
  RETIREMENT_PLANNED: '폐기 예정',
  // 오너 결정 2026-09-18 — 행사·인증·테스트·사내로 나가 있는 로봇.
  // (이 파일은 대시보드 KPI 용 별도 표기다 — 로봇 목록·배지는
  //  @bhops/shared 의 ROBOT_STATUS_LABELS 를 쓴다. 헤더 주석 참고.)
  OTHER: '기타',
};

/**
 * Resolve a Korean label for a RobotStatus value with a safe fallback.
 * Useful when the value comes from an external surface (URL filter,
 * server response from a future enum value, etc.) and might not be in
 * the static map yet.
 */
export function robotStatusLabel(status: RobotStatus | string): string {
  return ROBOT_STATUS_LABEL[status as RobotStatus] ?? status;
}
